export default __webpack_public_path__ + "static/media/logo_default.e09d7f80.gif";